import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/vancation_banner.png';
import _imports_1 from '../../assets/img/edu_jinggxy.png';
import _imports_2 from '../../assets/img/edu_xiaoqgj.png';
const _withScopeId = n => (_pushScopeId("data-v-1e35866a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"web-banner\" data-v-1e35866a><img src=\"" + _imports_0 + "\" alt=\"\" data-v-1e35866a><div class=\"banner-word flex align-items\" data-v-1e35866a><h3 data-v-1e35866a>职业教育服务</h3><h4 data-v-1e35866a>外引“⽔”内调剂、探索⾼质量就业</h4></div></div><div class=\"web-column column-info-common\" data-v-1e35866a><h3 data-v-1e35866a>我们的服务</h3><p data-v-1e35866a>公司以协同育⼈推进产教深度融合，逐步形成从招⽣、培养、就业⼀体化职业教育服务模式</p><div class=\"vocational-intro-icons\" data-v-1e35866a><div class=\"intro-icon flex\" data-v-1e35866a><i class=\"iconfont icon-service1\" data-v-1e35866a></i><h3 data-v-1e35866a>专业优化</h3><p data-v-1e35866a>根据企业需求对现有专业培养模式进⾏优化，⾯向新⽣或在校⽣进⾏培养（从在校⽣中选拔或者双⽅共同招⽣），双⽅结合实际情况，分担教学的实施与管理等⼯作。</p></div><div class=\"intro-icon flex\" data-v-1e35866a><i class=\"iconfont icon-service2\" data-v-1e35866a></i><h3 data-v-1e35866a>专业建设</h3><p data-v-1e35866a>根据企业需求提供专业建设⽅案，学校负责申办新专业，双⽅共同招⽣，教学的实施与管理由双⽅协商确定并共同执⾏。</p></div><div class=\"intro-icon flex\" data-v-1e35866a><i class=\"iconfont icon-service3\" data-v-1e35866a></i><h3 data-v-1e35866a>校企共建</h3><p data-v-1e35866a>双⽅结合实际情况，发挥各⾃优势，选择部分专业合作，以学院的形式独⽴运作，双⽅共同招⽣，双⽅共同承担教学的实施与管理。</p></div><div class=\"intro-icon flex\" data-v-1e35866a><i class=\"iconfont icon-service4\" data-v-1e35866a></i><h3 data-v-1e35866a>校外实训基地建设</h3><p data-v-1e35866a>根据校内实践教学的延伸需求，在企业设⽴实训实习基地，通过在真实职业环境下的岗位实践，有效提⾼学⽣的技能⽔平，使学⽣完成关键能⼒的培养。同时对带队学校⽼师提供培训，推动“双师型”教师队伍的建设，由企业全⾯实施⽇常运营管理。</p></div></div></div><div class=\"web-column\" data-v-1e35866a><h1 data-v-1e35866a>核心业务</h1><div class=\"core-business-column\" data-v-1e35866a><h3 data-v-1e35866a>精工学院</h3><div class=\"business-intro\" data-v-1e35866a><p data-v-1e35866a>致⼒于探索⼈才培养的新模式、新⽅向。</p><p data-v-1e35866a>以“立德树人”的教育理念对标职业标准，培养学生职业素养；通过⼈才及引进普⼯近万⼈次。定制化专业课程教学、企业游学、一线历练、角色实践学习路径，提升专业技能；将职业精神、工匠精神贯穿培养全过程，培养出企业“免检”人才。 以安徽为中心，计划至2025年，与全国职业院校合作成立爱沃客二级学院（精工学院）10所，预计在校生将达到10000人，打造特色职业教育品牌。</p><p data-v-1e35866a>以安徽为中心，计划至2025年，与全国职业院校合作成立爱沃客二级学院（精工学院）10所，预计在校生将达到10000人，打造特色职业教育品牌。</p><img src=\"" + _imports_1 + "\" alt=\"\" data-v-1e35866a></div></div><div class=\"core-business-column\" data-v-1e35866a><h3 data-v-1e35866a>校企共建</h3><div class=\"business-intro\" data-v-1e35866a><p data-v-1e35866a>企业深度参与学校专业规划、教材开发、教学设计、课程设置、实习实训，企业需求融⼊⼈才培养环节，推⾏⾯向企业真实⽣产环境的任务式培养模式。学校为学⽣创造更具竞争⼒的培养环境，让其学有专攻、学有所⽤，实现资源共享合作共赢。</p><p data-v-1e35866a>通过校企合作为主线，整合各类学校资源，深耕校企共建，利⽤精细化合作模式与学校建⽴⻓期有效的⼈⼒资源储备机制，为企业做好技能型⼈才培养和储备。</p><img src=\"" + _imports_2 + "\" alt=\"\" data-v-1e35866a></div></div></div>", 3);
const _hoisted_5 = {
  class: "web-column"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "目前成果", -1));
const _hoisted_7 = {
  class: "fruit-column"
};
const _hoisted_8 = {
  key: 0,
  class: "first-fruit"
};
const _hoisted_9 = {
  class: "img"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "date"
};
const _hoisted_12 = {
  class: "title van-multi-ellipsis--l2"
};
const _hoisted_13 = {
  class: "other-fruit"
};
const _hoisted_14 = {
  key: 0,
  class: "other-fruit-list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = {
  class: "van-multi-ellipsis--l2"
};
const _hoisted_18 = {
  class: "date"
};
const _hoisted_19 = {
  class: "img"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "more flex"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-more"
}, null, -1));
const _hoisted_23 = {
  class: "web-column grey-bg"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "合作学校", -1));
const _hoisted_25 = {
  class: "cooperate-school-column"
};
const _hoisted_26 = {
  class: "cooperate-school flex"
};
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = {
  class: "web-column"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "联系我们", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "column-h2"
}, "专属顾问·一对一服务", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  const _component_contact_us = _resolveComponent("contact-us");
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [$data.dataNews[0] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = $event => $options.actionTo('/news/' + $data.dataNews[0].newsid))
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: $data.dataNews[0].imageMax
  }, null, 8, _hoisted_10), _createElementVNode("p", _hoisted_11, _toDisplayString($data.dataNews[0].addtime_str), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString($data.dataNews[0].description ? $data.dataNews[0].description : $data.dataNews[0].title), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataNews, (item, key) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: key
    }, [key != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: $event => $options.actionTo('/news/' + item.newsid),
      class: "flex"
    }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("h3", _hoisted_17, _toDisplayString(item.description ? item.description : item.title), 1), _createElementVNode("p", _hoisted_18, _toDisplayString(item.addtime_str), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
      src: item.imageUrl
    }, null, 8, _hoisted_20)])], 8, _hoisted_15)])) : _createCommentVNode("", true)], 64);
  }), 128))]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "primary",
      round: "",
      color: "#16A0F0",
      onClick: _cache[1] || (_cache[1] = $event => $options.actionTo('/news?flag=jinggong'))
    }, {
      default: _withCtx(() => [_createTextVNode("More"), _hoisted_22]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])])])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataAd, (item, key) => {
    return _openBlock(), _createElementBlock("div", {
      class: "school-logo",
      key: key
    }, [_createElementVNode("img", {
      src: item.imageUrl,
      alt: item.qname
    }, null, 8, _hoisted_27), _createElementVNode("h3", null, _toDisplayString(item.qname), 1)]);
  }), 128))])])]), _createElementVNode("div", _hoisted_28, [_hoisted_29, _hoisted_30, _createVNode(_component_contact_us, {
    scenario: $data.scenario
  }, null, 8, ["scenario"])]), _createVNode(_component_bottom_foot)]);
}